import React from 'react';
import { capitalizeFirstLetter } from 'formatters';
import { Stack, Typography } from '@mui/material';

import { Details } from './Details';
import { EMPTY_VALUE, getChangeAction } from './lib';

interface Props {
  value: Record<string, any>;
}

export const ContactsChanges = ({ value }: Props) => {
  const { before, after } = value;
  const action = getChangeAction(before ?? null, after ?? null);

  const rows = [
    {
      label: 'Full Name',
      before: before?.fullName ?? EMPTY_VALUE,
      after: after?.fullName ?? EMPTY_VALUE,
      rawBefore: before?.fullName,
      rawAfter: after?.fullName,
    },
  ];

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" fontWeight={500}>
        {`${capitalizeFirstLetter(action)} contact`}
      </Typography>

      <Details action={action} rows={rows} />
    </Stack>
  );
};
